import { each, findIndex, memoize, sortBy } from 'lodash'
import { SelectItem } from 'Types/item'
import {
	PaymentStatus,
	STATUS_RBIDOS_REQUEST,
	RegistratorCabinetPayment,
	RbidosRequestStatuses,
} from 'Pages/registratorCabinet'

export const optionsStatus = memoize(
	(dictionary: typeof STATUS_RBIDOS_REQUEST): Array<SelectItem & { doubles: string }> => {
		const options = []
		each(dictionary, (val, key) => {
			const prevIndex = findIndex(options, { name: val.name })
			if (prevIndex === -1) {
				options.push({
					id: key,
					name: val.name,
					doubles: key,
				})
			} else {
				options[prevIndex].doubles = `${options[prevIndex].doubles},${key}`
			}
		})
		return sortBy(options, 'name')
	}
)

export const getPaymentStatus = (
	payment: Pick<RegistratorCabinetPayment, 'status'> | null,
	status: string
): PaymentStatus => {
	if (payment?.status === 'APPROVED' || payment?.status === 'DEPOSITED') return 'paid'

	if ((!payment || payment?.status === 'CREATED') && status === 's_docs_loaded')
		return 'readyForPay'

	return 'notPaid'
}

export const isBlockedStatus = (status: RbidosRequestStatuses): boolean => {
	const blockedStatuses: RbidosRequestStatuses[] = [
		RbidosRequestStatuses.S_EXECUTION,
		RbidosRequestStatuses.S_CI_WAIT_PKCS10,
		RbidosRequestStatuses.S_CI_WAIT_CONSUMER_IDENTIFICATION,
		RbidosRequestStatuses.S_CI_CERTIFICATE_ISSUE,
		RbidosRequestStatuses.S_CI_COMPLETE,
		RbidosRequestStatuses.S_CI_WAIT_SCAN_UPLOAD,
		RbidosRequestStatuses.S_RBIDOS_FNS_PACKAGE_SEND,
		RbidosRequestStatuses.S_RBIDOS_FNS_REGISTRATION_COMPLETED_NO_DOS,
		RbidosRequestStatuses.S_RBIDOS_FNS_RECEIPT_RECEIVED,
		RbidosRequestStatuses.S_RBIDOS_GOT_FNS_RESULT,
	]

	return blockedStatuses.includes(status)
}

export const trimQuotes = (value: string) => {
	if (!value) return ''
	return value
		.replace(/"(\s|")*"/g, '"')
		.split('"')
		.map((part) => part.trim())
		.join('"')
		.replace(/(?<=\S)"(?=\S)/g, ' "')
}
